module.exports = __webpack_public_path__ + "img/flowers-card-1024.cf7dae27.jpg";